import { render } from "./OrganizationSetting.vue?vue&type=template&id=5344d476"
import script from "./OrganizationSetting.vue?vue&type=script&lang=js"
export * from "./OrganizationSetting.vue?vue&type=script&lang=js"

import "./OrganizationSetting.vue?vue&type=style&index=0&id=5344d476&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__